import React, { useEffect, useState } from 'react'
import { Col, Row, Form, Collapse, Switch, Input, Button, Tooltip } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { SaveClientCompanySupplier } from '../../../../../Services/Corporate'
import { connect, useDispatch } from 'react-redux'
import commonStyles from '../../../../../Utils/Common.less'
import type {
    SupplierDetailsFormData,
    SupplierInfoInterFaceSoleTrader,
} from '../../../../../Types/Supplier'
import { SuccessMessage } from '../../../../../Utils/Notification'
import ActivePremission from '../../../../../Utils/premissins'
import { PermissionType } from '../../../../../Types/Enum/PermissionType'
import { getClientCompanyDetails } from '../../../../../Services/SoleTrader'
import { setLoadingStatus } from '../../../../../Reducer/Common'

const SupplierInfo = (
    props: SupplierInfoInterFaceSoleTrader
): React.ReactElement => {
    const { supplierInfoList, soleTraderId } = props
    const { Panel } = Collapse
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [supplierData, setSupplierData] = useState<
        Record<number, SupplierDetailsFormData>
    >({})
    const [activeSuppliers, setActiveSuppliers] = useState<
        Record<number, boolean>
    >({})
    useEffect(() => {
        // Check if supplierInfoList is an array before attempting to iterate
        if (Array.isArray(supplierInfoList)) {
            const initialActiveSuppliers: Record<number, boolean> = {}

            supplierInfoList?.forEach((supplier: any) => {
                if (
                    supplier?.clientCompanySupplierId !== 0 &&
                    supplier?.referenceId !== 0 &&
                    supplier?.status !== 'Inactive'
                ) {
                    initialActiveSuppliers[supplier?.supplierId] = true
                } else {
                    initialActiveSuppliers[supplier?.supplierId] = false
                }
            })

            setActiveSuppliers(initialActiveSuppliers)
        }
    }, [supplierInfoList])

    const handleToggle = (supplierId: number, checked: boolean): void => {
        setActiveSuppliers((prev) => ({
            ...prev,
            [supplierId]: checked,
        }))
        const supplier = supplierInfoList.find(
            (sup: { supplierId: number }) => sup.supplierId === supplierId
        )
        if (checked) {
            if (supplier !== null) {
                setSupplierData((prev) => ({
                    ...prev,
                    [supplierId]: { ...supplier, status: 'Active' },
                }))
            }
        } else {
            setSupplierData((prev) => ({
                ...prev,
                [supplierId]: {
                    ...supplier,
                    userName: '',
                    password: '',
                    consumerNo: '',
                    url: '',
                    status: 'Inactive',
                },
            }))
        }
    }
    const handleInputChange = (
        supplierId: number,
        field: keyof SupplierDetailsFormData,
        value: string
    ): void => {
        setSupplierData((prev) => ({
            ...prev,
            [supplierId]: {
                ...prev[supplierId],
                [field]: value,
            },
        }))
    }
    const handleSave = (): void => {
        void saveSupplierData()
    }

    const saveSupplierData = async (): Promise<void> => {
        // Convert supplierData object to an array and append additional fields
        const updatedDetails = Object.values(supplierData).map(
            (detail: SupplierDetailsFormData) => ({
                companyType: 2,
                referenceId: soleTraderId,
                supplierId: detail.supplierId,
                supplierName: detail.supplierName,
                clientCompanySupplierId: detail.clientCompanySupplierId,
                userName: detail.userName ?? '',
                password: detail.password ?? '',
                consumerNo: detail.consumerNo ?? '',
                url: detail.url ?? '',
                status: detail.status,
            })
        )

        try {
            if (updatedDetails?.length !== 0) {
                dispatch(setLoadingStatus({ status: true }))
                await Promise.all(
                    updatedDetails.map(
                        async (updatedDetail: SupplierDetailsFormData) => {
                            return await SaveClientCompanySupplier(
                                dispatch,
                                updatedDetail
                            )
                        }
                    )
                )
                setTimeout(() => {
                    setSupplierData({})
                    void getClientCompanyDetails(dispatch, 2, soleTraderId, 7)
                    dispatch(setLoadingStatus({ status: false }))
                    SuccessMessage('Supplier Info Saved Successfully')
                }, 5000)
            }
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <Form
            name="complex-form"
            labelCol={{ span: 16 }}
            wrapperCol={{ span: 16 }}
            layout={'vertical'}
            autoComplete="off"
            form={form}
        >
            <Row gutter={16}>
                <Col span={24}>
                    <Collapse defaultActiveKey={['1']}>
                        <Panel header="Supplier Info" key="1">
                            {supplierInfoList?.length > 0 &&
                                supplierInfoList?.map(
                                    (supplier: any, index: number) => (
                                        <Row key={index}>
                                            <Col span={12}>
                                                <Row>
                                                    <div
                                                        className={
                                                            commonStyles.SupplierInfoList
                                                        }
                                                    >
                                                        <Switch
                                                            checked={
                                                                !!activeSuppliers[
                                                                    supplier
                                                                        .supplierId
                                                                ]
                                                            }
                                                            onChange={(
                                                                checked
                                                            ) => {
                                                                handleToggle(
                                                                    supplier.supplierId,
                                                                    checked
                                                                )
                                                            }}
                                                            className={
                                                                commonStyles.SupplierInfoSwitch
                                                            }
                                                        />
                                                    </div>
                                                    <div
                                                        className={
                                                            commonStyles.SupplierInfoList
                                                        }
                                                    >
                                                        {supplier.supplierName}
                                                    </div>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row>
                                                    {activeSuppliers[
                                                        supplier.supplierId
                                                    ] && (
                                                        <>
                                                            <div
                                                                className={
                                                                    commonStyles.SupplierInfoList
                                                                }
                                                            >
                                                                <Form.Item
                                                                    name={[
                                                                        'details',
                                                                        index,
                                                                        'userName',
                                                                    ]}
                                                                    initialValue={
                                                                        supplier.userName
                                                                    }
                                                                    label="UserName"
                                                                >
                                                                    <Input
                                                                        type="text"
                                                                        placeholder="User Name"
                                                                        value={
                                                                            supplierData[
                                                                                supplier
                                                                                    .supplierId
                                                                            ]
                                                                                ?.userName ??
                                                                            ''
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            handleInputChange(
                                                                                supplier.supplierId,
                                                                                'userName',
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }}
                                                                        maxLength={
                                                                            100
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            <div
                                                                className={
                                                                    commonStyles.SupplierInfoList
                                                                }
                                                            >
                                                                <Form.Item
                                                                    name={[
                                                                        'details',
                                                                        index,
                                                                        'password',
                                                                    ]}
                                                                    initialValue={
                                                                        supplier.password
                                                                    }
                                                                    label="Password"
                                                                >
                                                                    <Input
                                                                        type="text"
                                                                        placeholder="Password"
                                                                        value={
                                                                            supplierData[
                                                                                supplier
                                                                                    .supplierId
                                                                            ]
                                                                                ?.password ??
                                                                            ''
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            handleInputChange(
                                                                                supplier.supplierId,
                                                                                'password',
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }}
                                                                        maxLength={
                                                                            8
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            <div
                                                                className={
                                                                    commonStyles.SupplierInfoList
                                                                }
                                                            >
                                                                <Form.Item
                                                                    name={[
                                                                        'details',
                                                                        index,
                                                                        'consumerNo',
                                                                    ]}
                                                                    initialValue={
                                                                        supplier.consumerNo
                                                                    }
                                                                    label="Customer #"
                                                                >
                                                                    <Input
                                                                        type="text"
                                                                        placeholder="Customer"
                                                                        value={
                                                                            supplierData[
                                                                                supplier
                                                                                    .supplierId
                                                                            ]
                                                                                ?.consumerNo ??
                                                                            ''
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            handleInputChange(
                                                                                supplier.supplierId,
                                                                                'consumerNo',
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }}
                                                                        maxLength={
                                                                            100
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            <div
                                                                className={
                                                                    commonStyles.SupplierInfoList
                                                                }
                                                            >
                                                                <Form.Item
                                                                    name={[
                                                                        'details',
                                                                        index,
                                                                        'url',
                                                                    ]}
                                                                    initialValue={
                                                                        supplier.url
                                                                    }
                                                                    label="URL"
                                                                >
                                                                    <Input
                                                                        type="text"
                                                                        placeholder="URL"
                                                                        value={
                                                                            supplierData[
                                                                                supplier
                                                                                    .supplierId
                                                                            ]
                                                                                ?.url ??
                                                                            ''
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            handleInputChange(
                                                                                supplier.supplierId,
                                                                                'url',
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }}
                                                                        maxLength={
                                                                            100
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                        </>
                                                    )}
                                                </Row>
                                            </Col>
                                        </Row>
                                    )
                                )}
                            {ActivePremission('3000', PermissionType.SAVE) && (
                                <Row gutter={16}>
                                    <Col offset={20} span={2}>
                                        <Tooltip title={'Save changes'}>
                                            <Button
                                                type="primary"
                                                onClick={handleSave}
                                            >
                                                <SaveOutlined />
                                            </Button>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            )}
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
        </Form>
    )
}

const mapStateToProps = (state: any): any => {
    return {
        supplierInfoList: state.client.soleTraderTaps,
    }
}

export default connect(mapStateToProps)(SupplierInfo)
